module.exports = __webpack_public_path__ + "img/list.556d8694.svg";